<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Filtrar Acompanhamento' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card-content>
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ng-container>
          <ion-row class="border-bottom">
            <ion-col size="12">
              <prover-datepicker
                class="border-bottom"
                [labelName]="'Data Início'"
                [id]="'dataInicio'"
                [(dateTime)]="dataInicio"
                formControlName="dataInicio"
              ></prover-datepicker>
            </ion-col>
          </ion-row>
        </ng-container>

        <ng-container>
          <ion-row class="border-bottom">
            <ion-col size="12">
              <prover-datepicker
                class="border-bottom"
                [labelName]="'Data Fim'"
                [id]="'dataFim'"
                [(dateTime)]="dataFim"
                formControlName="dataFim"
              ></prover-datepicker>
            </ion-col>
          </ion-row>
        </ng-container>

        <ion-row class="border-bottom">
          <ion-col size="11" class="ion-margin-horizontal">
            <ion-select
              labelPlacement="stacked"
              interface="action-sheet"
              placeholder="{{'Categoria' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idCategoria"
              (ionChange)="changeAcao($event)"
            >
              <div slot="label" class="slot-label">{{'Categoria' | translate}}</div>
              <ion-select-option *ngFor="let categoria of categoriaList" [value]="categoria.id">
                {{categoria.titulo}}
              </ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>

        <ion-row class="border-bottom">
          <ion-col size="11" class="ion-margin-horizontal">
            <ion-select
              labelPlacement="stacked"
              interface="action-sheet"
              placeholder="{{'Ação' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idAcompanhamentoOperacao"
              value="0"
            >
              <div slot="label" class="slot-label">{{'Ação' | translate}}</div>
              <ion-select-option [value]="0">{{'Todos' | translate}}</ion-select-option>
              <ion-select-option *ngFor="let acao of acaoList" [value]="acao.id">{{acao.nome}}</ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>

        <div class="down">
          <ion-button class="btn-default" expand="block" type="submit" [disabled]="!validations_form.valid">
            {{'Filtrar' | translate}}
          </ion-button>
        </div>
      </ion-grid>
    </form>
  </ion-card-content>
</ion-content>
